import React, { useState } from 'react';

import { requestResend } from './api';
import ActionButton from './components/ActionButton';
import Layout from './components/Layout';
import PortalCard from './components/PortalCard';
import { palette } from './styles';
import { onboardColors } from '../theme/onboardTokens';

interface Props {
  token: string;
  offerTitle?: string;
  canResend: boolean;
}

const PortalExpired: React.FC<Props> = ({ token, offerTitle, canResend }) => {
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);

  const handleResend = async () => {
    setStatus('sending');
    try {
      await requestResend(token);
      setStatus('sent');
    } catch (e) {
      setStatus('error');
      setError(e instanceof Error ? e.message : 'Failed to request a new link');
    }
  };

  return (
    <Layout title={offerTitle ?? 'Onboard portal'}>
      <PortalCard variant="message">
        <h2 style={{ color: palette.headingNeutral, fontSize: 24, margin: '0 0 8px' }}>
          This link has expired
        </h2>
        <p style={{ color: palette.bodyNeutral, fontSize: 16, margin: '0 0 24px' }}>
          Request a new portal link to continue.
        </p>
        {canResend && status !== 'sent' ? (
          <ActionButton
            disabled={status === 'sending'}
            label={status === 'sending' ? 'Requesting…' : 'Request a new link'}
            onClick={handleResend}
            variant="primary"
          />
        ) : null}
        {status === 'sent' ? (
          <div
            style={{
              margin: '24px auto 0',
              maxWidth: 560,
              border: `1px solid ${palette.green}`,
              borderRadius: 12,
              background: '#F3FBF4',
              textAlign: 'left',
              padding: '12px 16px'
            }}
          >
            <p
              style={{
                color: palette.headingNeutral,
                fontSize: 16,
                fontWeight: 700,
                margin: '0 0 4px'
              }}
            >
              Request sent
            </p>
            <p style={{ color: palette.bodyNeutral, fontSize: 14, margin: 0 }}>
              We have notified the hiring team that you requested a new portal link.
            </p>
          </div>
        ) : null}
        {status === 'error' ? (
          <div
            style={{
              margin: '24px auto 0',
              maxWidth: 560,
              border: `1px solid ${palette.warning}`,
              borderRadius: 12,
              background: onboardColors.statusWash.errorSoft,
              textAlign: 'left',
              padding: '12px 16px'
            }}
          >
            <p style={{ color: palette.warning, fontSize: 14, margin: 0 }}>
              {error ?? 'Failed to request a new link'}
            </p>
          </div>
        ) : null}
      </PortalCard>
    </Layout>
  );
};

export default PortalExpired;
